import React from "react";
import KioskStartButton from "../components/start-button";
import HoldingBG from "./holding-bg";

export default function HoldingScreen({ navigate, setInputWeight }) {
  return (
    <>
      <div className="z-1">
        <HoldingBG />
      </div>
      <div className="flex flex-col items-center w-full h-full px-[3vh] z-2 relative">
        <h1 className="text-[40px] mt-[2vh] text-white">
          LEGO® Brick Take Back
        </h1>

        <div className="flex flex-col gap-[0vh] items-center mt-[8vh] text-white">
          <p className="text-[80px] leading-[120%] text-center max-w-[1200px] mb-[3vh] text-white">
            Trade in your LEGO® bricks <br />
            for a LEGO e-Gift Card
          </p>
        </div>

        <div className="absolute flex w-full bottom-4 px-[3vh] justify-center w-full">
          <KioskStartButton
            className={"bg-[rgba(0,0,0,0.05)] mr-12"}
            iconColor="white"
            onClick={() => navigate("qrCode")}
            icon="arrow_back"
          ></KioskStartButton>

          <KioskStartButton
            className="font-semibold min-w-[270px]"
            iconShow={false}
            onClick={() => {
              setInputWeight(0);
              navigate("tncs");
            }}
          >
            Start
          </KioskStartButton>
        </div>
      </div>
    </>
  );
}
